<div>
    <div class="attachment-conditions">
        <mat-label
            class="mat-label"
            i18n
            >Attachment
        </mat-label>
        <div class="m-t-16"><span i18n>Max. size</span>: {{ maxSize }} <span i18n>MB</span></div>
        <div><span i18n>Extensions</span>: {{ extensionsAllowed.join(', ') }}</div>
    </div>

    <input
        #uploadInputElement
        (change)="onAttachmentUpload($event)"
        [accept]="extensionsAllowed.join(',')"
        hidden
        type="file"
    />
    <button
        (click)="uploadInputElement.click()"
        [disabled]="browseButtonDisabled"
        class="browse-button"
        color="primary"
        i18n
        mat-flat-button
        type="button"
    >
        Browse
    </button>

    @if (AttachmentControl?.value) {
    <mat-chip-listbox
        class="mat-chip-list-stacked"
        aria-orientation="vertical"
    >
        <mat-chip
            class="auto-width"
            disableRipple
        >
            {{ AttachmentControl?.value.name }}
            <mat-icon
                matChipRemove
                style="color: black; opacity: 0.8"
                (click)="removeAttachment()"
            >
                cancel
            </mat-icon>
        </mat-chip>
    </mat-chip-listbox>
    }
</div>
